import api from './client';

export interface ReviewRequestCandidate {
  order_id: number | null;
  customer_name: string;
  email: string | null;
  product_title: string;
  days_since_order: number;
}

export interface ReviewRequestRecommendationItem {
  customer_name: string;
  product_title: string;
  email_subject: string;
  email_body: string;
  rationale: string;
}

export interface ReviewRequestCampaign {
  id: number;
  min_days_since_order: number;
  orders_analyzed: number;
  candidates: ReviewRequestCandidate[];
  ai_summary: string | null;
  ai_recommendations: ReviewRequestRecommendationItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GenerateReviewRequestPayload {
  min_days_since_order?: number;
}

export const reviewRequestApi = {
  list: (page = 1) =>
    api.get<{ data: ReviewRequestCampaign[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/review-requests?page=${page}`
    ),

  generate: (payload: GenerateReviewRequestPayload = {}) =>
    api.post<{ data: ReviewRequestCampaign }>('/review-requests/generate', payload),

  show: (id: number) => api.get<{ data: ReviewRequestCampaign }>(`/review-requests/${id}`),

  destroy: (id: number) => api.delete(`/review-requests/${id}`),
};
